import type { PendingSocialLink } from '@/auth';

// ENG-6309: "Continue with Google" or "Continue with Microsoft" on a signup
// form named an account that must sign in with its password first. Log in
// takes the provider's answer from here and connects it after the password and
// 2FA, as when the answer came on Log in itself.
//
// As with the social sign-up handoff, the ID token stays in this module's
// memory and router state carries only a reference: a reload, another tab or
// logout resolves nothing, and Log in shows its plain form.
const LINK_TTL_MS = 30 * 60 * 1000;

const links = new Map<string, { link: PendingSocialLink; expiresAt: number }>();

/** Router state for the Log in link that carries a pending connection. */
export function pendingSocialLinkState(link: PendingSocialLink): { pendingSocialLink: string } {
  const ref = crypto.randomUUID();
  links.set(ref, { link, expiresAt: Date.now() + LINK_TTL_MS });
  return { pendingSocialLink: ref };
}

export function readPendingSocialLink(state: unknown): PendingSocialLink | undefined {
  if (typeof state !== 'object' || state === null) return undefined;
  const ref = (state as Record<string, unknown>).pendingSocialLink;
  if (typeof ref !== 'string') return undefined;
  const entry = links.get(ref);
  if (!entry) return undefined;
  if (Date.now() >= entry.expiresAt) {
    links.delete(ref);
    return undefined;
  }
  return entry.link;
}

/** Forgets every pending connection, on logout. */
export function clearPendingSocialLinks(): void {
  links.clear();
}
